import axios from 'axios'
import NProgress from 'nprogress'

import { getSSORedirectUrl } from '../helpers/ssoHelper'

axios.interceptors.request.use(config => {
  NProgress.start()
  return config
})

axios.interceptors.response.use(response => {
  NProgress.done()
  return response
})

const baseDomain = process.env.VUE_APP_BASEDOMAIN
const configDomain = process.env.VUE_APP_CONFIGDOMAIN
const baseEnv = process.env.VUE_APP_BASEENV
const securityUrl = process.env.VUE_APP_FANBASESECURITY
const fanPageUrl = process.env.VUE_APP_FANPAGEDOMAIN
const baseUrl = `${baseDomain}/${baseEnv}`
const baseSecurityUrl = `${securityUrl}/${baseEnv}`
const baseFanPageUrl = `${fanPageUrl}/${baseEnv}`

export class loginFB {
  constructor() {}

  async getLoginConf(domain, subdomain) {
    try {
      const params = new URL(window.location.href).searchParams
      const clientId = params.get('client_id')
      const pathCustom = clientId ? `${clientId}` : `${subdomain}-${domain}`

      const urls = [
        `${configDomain}/sys/login/${domain}/custom/${pathCustom}/login-setup.json`,
        `${configDomain}/sys/login/${domain}/${subdomain}/login-setup.json`,
      ]

      for (let templateUrl of urls) {
        try {
          const response = await axios.get(templateUrl)
          if (response.data) return response.data
        } catch (err) {
          console.error('Error fetching login template:', err)
        }
      }
    } catch (err) {
      console.error(err)
    }
  }

  createAccount(data) {
    return new Promise((resolve, reject) => {
      const cmd = `${baseSecurityUrl}/account`

      axios.post(cmd, data).then(
        r => {
          if (r.data.header.codigo == 1) {
            resolve(r.data.data)
          } else {
            reject(r.data.header.msg)
          }
        },
        err => {
          reject(err)
        },
      )
    })
  }

  createGuardian(data) {
    return new Promise((resolve, reject) => {
      const cmd = `${baseSecurityUrl}/account/createGuardian`

      axios.post(cmd, data).then(
        r => {
          if (r.data.header.codigo == 1) {
            resolve(r.data.data)
          } else {
            reject(r.data.header.msg)
          }
        },
        err => {
          reject(err)
        },
      )
    })
  }

  newAccountPassword(data) {
    return new Promise((resolve, reject) => {
      const cmd = `${baseSecurityUrl}/account/NewPassword`

      axios.post(cmd, data).then(
        r => {
          if (r.data.header.codigo == 1) {
            resolve(r.data.data)
          } else {
            reject(r.data.header.msg)
          }
        },
        err => {
          reject(err)
        },
      )
    })
  }

  recoverPwd(data) {
    return new Promise((resolve, reject) => {
      const cmd = `${baseSecurityUrl}/pwd`

      axios.post(cmd, data).then(
        r => {
          if (r.data.header.codigo == 1) {
            resolve(r.data.data)
          } else {
            reject(r.data.header.msg)
          }
        },
        err => {
          reject(err)
        },
      )
    })
  }

  login(payload, bySession = false) {
    return new Promise((resolve, reject) => {
      let cmd = bySession ? `${baseSecurityUrl}/login/bysession` : `${baseSecurityUrl}/login`

      if (payload.systemId == 100 && !bySession) {
        let mode = baseSecurityUrl.includes('fantest')
          ? 'https://dashv2.fantest.com.br'
          : 'https://dash.fanbox.app.br'

        cmd = `${baseSecurityUrl}/authorize?response_type=code&scope=openid&client_id=fanbox2&redirect_uri=${mode}`
      }

      axios.post(cmd, payload).then(
        r => {
          if (r.data.header.codigo == 1) {
            resolve(r.data.data)
          } else {
            localStorage.removeItem('session')
            location.reload()
            const msg = r.data.header && r.data.header.msg && String(r.data.header.msg).trim()
            reject(msg || 'Confirme seus dados.')
          }
        },
        err => {
          reject('Confirme sua conexão. ' + err.message)
        },
      )
    })
  }

  Authorize(loginInfo, oauthData, bySession = false, config = null) {
    return new Promise((resolve, reject) => {
      const dontUseSso =
        !config ||
        !config.sso ||
        !config.sso.clientId ||
        !config.sso.redirectUrl ||
        Object.keys(oauthData).length

      let url = bySession
        ? `${baseSecurityUrl}/authorize/bysession`
        : dontUseSso
        ? `${baseSecurityUrl}/authorize`
        : `${baseSecurityUrl}/${getSSORedirectUrl(config, true)}`

      if (dontUseSso) {
        let queryString = new URLSearchParams(oauthData).toString()
        url += `?${queryString}`
      }

      axios.post(url, loginInfo).then(
        r => {
          if (r.data.header.codigo == 1) {
            resolve(r.data.data)
          } else if (r.data.header.codigo == 3) {
            window.location.href = r.data.data
          } else {
            const msg = r.data.header && r.data.header.msg && String(r.data.header.msg).trim()
            reject(msg || 'Confirme seus dados.')
          }
        },
        err => {
          const msg =
            err.response &&
            err.response.data &&
            err.response.data.header &&
            err.response.data.header.msg &&
            String(err.response.data.header.msg).trim()
          reject(msg || 'Confirme sua conexão.')
        },
      )
    })
  }

  CheckTK(tk) {
    return new Promise((resolve, reject) => {
      const cmd = `${baseUrl}/checkLogin`
      const header = { headers: { Authorization: `Bearer ${tk}` } }

      axios.post(cmd, null, header).then(
        r => {
          if (r.data.header.codigo === 1) resolve(r.data)
          else reject(r.data.header.msg)
        },
        () => {
          reject()
        },
      )
    })
  }

  validateAuthorizeRequest(oauthData) {
    return new Promise((resolve, reject) => {
      let url = `${baseSecurityUrl}/authorize/validateRequest`
      let queryString = new URLSearchParams(oauthData).toString()

      url += `?${queryString}`

      axios.get(url).then(
        r => {
          if (r.data.header.codigo == 3) {
            window.location.href = r.data.data
          } else if (r.data.header.codigo == 0) {
            reject(r.data.header.msg)
          } else resolve('ok')
        },
        err => {
          reject('Confirme sua conexão. ' + err.message)
        },
      )
    })
  }

  GetRedirectUrl(sessionToken, mode) {
    return new Promise((resolve, reject) => {
      let url = `${baseSecurityUrl}/session/redirection/${sessionToken}`

      axios.get(url).then(
        r => {
          if (r.data.header.codigo == 1) {
            if (mode && mode == true) {
              let url = new URL(r.data.data)
              url.searchParams.set('mode', 'visitor')
              r.data.data = url.toString()
              window.location.href = r.data.data
            } else {
              window.location.href = r.data.data
            }
          } else if (r.data.header.codigo == 0) {
            reject(r.data.header.msg)
          } else resolve('ok')
        },
        err => {
          reject('Confirme sua conexão. ' + err.message)
        },
      )
    })
  }

  GetCodeByRedirectUrl(sessionToken) {
    return new Promise((resolve, reject) => {
      let url = `${baseSecurityUrl}/session/redirection/${sessionToken}`

      axios.get(url).then(
        r => {
          if (r.data.header.codigo == 1) {
            resolve(r.data.data)
          } else if (r.data.header.codigo == 0) {
            reject(r.data.header.msg)
          } else resolve('ok')
        },
        err => {
          reject('Confirme sua conexão. ' + err.message)
        },
      )
    })
  }

  GetCountries() {
    return new Promise((resolve, reject) => {
      let url = `${baseSecurityUrl}/country`

      axios.get(url).then(
        r => {
          if (r.data.header.codigo == 1) {
            resolve(r.data.data)
          } else {
            reject(r.data.header.msg)
          }
        },
        err => {
          reject('Confirme sua conexão. ' + err.message)
        },
      )
    })
  }

  CheckSessionValidity(sessionToken) {
    return new Promise((resolve, reject) => {
      let url = `${baseSecurityUrl}/session/checkvalidity/${sessionToken}`

      axios.get(url).then(
        r => {
          if (r.data.header.codigo == 1) {
            resolve(r.data.data)
          } else if (r.data.header.codigo == 0) {
            resolve(false)
          } else resolve(false)
        },
        err => {
          reject('Confirme sua conexão. ' + err.message)
        },
      )
    })
  }

  getFileContentLoc(domain, subdomain) {
    return new Promise((resolve, reject) => {
      const url = `${configDomain}/sys/login/${domain}/${subdomain}/termos.html`

      axios.get(url).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(error)
        },
      )
    })
  }

  checkLogin(loginId, ownerId, clientName) {
    return new Promise((resolve, reject) => {
      const cmd = `${baseSecurityUrl}/Account/v2/check?client=${clientName}&ownerId=${ownerId}`
      const userCPF = loginId.replace(/\D/g, '')

      const payload = { userLogin: userCPF, NumberType: 1 }

      axios.post(cmd, payload).then(
        r => {
          if (r.data.header.codigo == 1) {
            resolve(r.data.data)
          } else {
            const msg = r.data.header && r.data.header.msg && String(r.data.header.msg).trim()
            reject(msg || 'Confirme seus dados.')
          }
        },
        err => {
          reject('Confirme sua conexão. ' + err.message)
        },
      )
    })
  }

  checkLoginV2(loginId, ownerId, clientName) {
    return new Promise((resolve, reject) => {
      const cmd = `${baseSecurityUrl}/account/check-account/?client=${clientName}&ownerId=${ownerId}`
      const userCPF = loginId.replace(/\D/g, '')

      const payload = { userLogin: userCPF, NumberType: 1 }

      axios.post(cmd, payload).then(
        r => {
          if (r.data.header.codigo == 1) {
            resolve(r.data.data)
          } else {
            const msg = r.data.header && r.data.header.msg && String(r.data.header.msg).trim()
            reject(msg || 'Confirme seus dados.')
          }
        },
        err => {
          reject('Confirme sua conexão. ' + err.message)
        },
      )
    })
  }

  checkGuardian(payload) {
    return new Promise((resolve, reject) => {
      const cmd = `${baseSecurityUrl}/account/check-guardian`

      axios.post(cmd, payload).then(
        r => {
          resolve(r.data)
        },
        err => {
          reject(err)
        },
      )
    })
  }

  checkUserEmail(clientName, cpf, email, sysId, ownerId) {
    return new Promise((resolve, reject) => {
      const cmd = `${baseSecurityUrl}/account/checkEmail/${clientName}`
      const userCPF = cpf ? cpf.replace(/\D/g, '') : null

      const payload = {
        cpf: userCPF,
        email,
        ...(sysId === '100' ? { sysId, ownerId } : { sysId, ownerId }),
      }

      axios.post(cmd, payload).then(
        res => {
          if (res.data.header.codigo === 1) {
            resolve(res.data)
          } else {
            const msg = res.data.header && res.data.header.msg && String(res.data.header.msg).trim()
            reject(msg || 'Confirme seus dados.')
          }
        },
        err => {
          reject('Confirme sua conexão. ' + err.message)
        },
      )
    })
  }
  sendEmailCodeToConfirm(email, identity, ownerId, name) {
    return new Promise((resolve, reject) => {
      const payload = {
        OwnerId: ownerId,
        Identity: identity,
        NumberType: 4,
        Number: email,
      }
      const url = `${baseSecurityUrl}/numberconfirmation/login/${name}`
      axios.post(url, payload).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        },
      )
    })
  }

  checkEmailCodeToConfirm(code, identifier, name, isEmailSentDirectly = false) {
    return new Promise((resolve, reject) => {
      const url = `${baseSecurityUrl}/numberconfirmation/check/login/${name}`

      const payload = isEmailSentDirectly
        ? { identity: identifier, Code: code }
        : { Email: identifier, Code: code }

      axios.post(url, payload).then(
        response => {
          const codesuccess = response.data.header.codigo
          resolve(codesuccess)
        },
        error => {
          reject(error)
        },
      )
    })
  }

  get2FAData(clientId, sessionToken) {
    return new Promise((resolve, reject) => {
      const url = `${baseSecurityUrl}/login/verification2FA/v2/${clientId}/${sessionToken}`

      axios.get(url).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(error)
        },
      )
    })
  }

  validate2FACode(sessionToken, code) {
    return new Promise((resolve, reject) => {
      const url = `${baseSecurityUrl}/session/validate2FACode/${sessionToken}/${code}`

      axios.get(url).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(error)
        },
      )
    })
  }

  resendVerificationCode(sessionToken, clientId, resendOption) {
    return new Promise((resolve, reject) => {
      let url = `${baseSecurityUrl}/session/verificationCodeResend/${clientId}/${sessionToken}`

      if (resendOption) {
        url += `/${resendOption}`
      }

      axios.get(url).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(error)
        },
      )
    })
  }

  updateFacialBiometry(payload) {
    return new Promise((resolve, reject) => {
      const url = `${baseUrl}/FanData/UpdateFacialBiometryV2`
      axios.post(url, payload).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(error)
        },
      )
    })
  }

  getAttributes(ownerId) {
    return new Promise((resolve, reject) => {
      const url = `${fanPageUrl}/api/Attribute/attributes/${ownerId}`

      axios
        .get(url)
        .then(response => {
          if (response.data.header.codigo === 1) {
            resolve(response.data.data)
          } else {
            reject(response.data.header.msg)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  checkFacialBiometry(identity, ownerId, systemId) {
    return new Promise((resolve, reject) => {
      const url = `${baseUrl}/FanData/CheckFacialBiometry/${identity}/${ownerId}/${systemId}`

      axios
        .get(url)
        .then(response => {
          if (response.data.header.codigo === 1) {
            resolve(response.data.data)
          } else {
            reject(response.data.header.msg)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  externalSSO(payload) {
    return new Promise((resolve, reject) => {
      const url = `${baseSecurityUrl}/login/externalSSO`

      axios.post(url, payload).then(
        r => {
          if (r.data.header.codigo == 1) {
            resolve(r.data.data)
          } else {
            const msg = r.data.header && r.data.header.msg && String(r.data.header.msg).trim()
            reject(msg || 'Confirme seus dados.')
          }
        },
        err => {
          reject('Confirme sua conexão. ' + err.message)
        },
      )
    })
  }
  getInternalOptinsByOwner(clientId, token) {
    return new Promise((resolve, reject) => {
      let url = `${baseFanPageUrl}/optin/internal_optins_owner/${clientId}`
      const header = { headers: { Authorization: `Bearer ${token}` } }

      axios.get(url, header).then(
        r => {
          if (r.data.header.codigo == 1) {
            resolve(r.data.data)
          } else {
            reject(r.data.header.msg)
          }
        },
        err => {
          reject('Confirme sua conexão. ' + err.message)
        },
      )
    })
  }

  /**
   * Fortface handshake: envia deviceRequestInfo e retorna sessionId e sessionKey para startSession.
   * @param {string} deviceRequestInfo - retornado por fortfaceSdk.start()
   * @param {string} token - Bearer JWT (ex.: obtido após login)
   * @returns {Promise<{ sessionId: string, sessionKey: string }>}
   */
  fortfaceHandshake(deviceRequestInfo, token) {
    return new Promise((resolve, reject) => {
      const url = `${fanPageUrl}/api/fortface/handshake`
      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        devicerequestinfo: deviceRequestInfo,
      }

      axios
        .post(url, {}, { headers })
        .then(r => {
          const data =
            r.data && r.data.data !== undefined && r.data.data !== null ? r.data.data : r.data

          if (data && data.sessionId != null && data.sessionKey != null) {
            resolve({
              sessionId: data.sessionId,
              sessionKey: data.sessionKey,
              sessionToken: data.sessionToken != null ? data.sessionToken : undefined,
            })
          } else {
            reject(
              (r.data && r.data.header && r.data.header.msg) || 'Resposta do handshake inválida.',
            )
          }
        })
        .catch(err => {
          const msg =
            (err.response &&
              err.response.data &&
              err.response.data.header &&
              err.response.data.header.msg) ||
            (err.response && err.response.data && err.response.data.message) ||
            (err && err.message)

          reject(msg)
        })
    })
  }

  /**
   * Fortface enroll/capture: envia o payload como no callback do SDK (action, externalUserId, encryptData, sessionDetails, imgPreview, sessionToken).
   * - encryptData.key: usa a key retornada pelo SDK na captura (base64); se não vier, usa sessionKey do handshake.
   * - deviceRequestInfo no header/body para o backend repassar ao Fortface (evitar 400 device_request_info.has_invalid).
   * @param {string} externalUserId - CPF do usuário
   * @param {object} data - objeto do callback: { encryptData: { data, imgData, key? }, imgPreview? }
   * @param {object} sessionDetails - do callback: { metrics?: { totalCaptureTime, downloadFiles, openCamera, captureTime } }
   * @param {string} sessionKey - chave do handshake (fallback para encryptData.key se o SDK não enviar)
   * @param {string} sessionToken - sessionToken do handshake
   * @param {string} deviceRequestInfo - deviceRequestInfo do SDK start (mesmo do handshake)
   * @param {string} token - Bearer JWT
   * @param {boolean} [returnPhoto] - opcional
   * @returns {Promise<object>} resposta da API
   */
  fortfaceCapture(
    externalUserId,
    data,
    sessionDetails,
    sessionKey,
    sessionToken,
    deviceRequestInfo,
    token,
    returnPhoto,
  ) {
    return new Promise((resolve, reject) => {
      const url = `${fanPageUrl}/api/fortface/capture`
      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }

      if (deviceRequestInfo != null && deviceRequestInfo !== '') {
        headers.devicerequestinfo = deviceRequestInfo
      }

      const enc = data.encryptData || {}
      const payload = {
        action: 'capture',
        externalUserId,
        encryptData: {
          data: enc.data,
          imgData: enc.imgData,
          key: enc.key != null && enc.key !== '' ? enc.key : sessionKey,
        },
        sessionToken: sessionToken != null ? sessionToken : undefined,
      }

      if (sessionDetails && sessionDetails.metrics) {
        payload.sessionDetails = { metrics: sessionDetails.metrics }
      }

      if (data.imgPreview != null && data.imgPreview !== '') {
        payload.imgPreview = data.imgPreview
      }

      if (deviceRequestInfo != null && deviceRequestInfo !== '') {
        payload.deviceRequestInfo = deviceRequestInfo
      }

      if (returnPhoto !== undefined && returnPhoto !== null) {
        payload.returnPhoto = returnPhoto
      }

      axios
        .post(url, payload, { headers })
        .then(r => {
          if (r.data && r.data.header && r.data.header.codigo === 1) {
            resolve(r.data.data != null ? r.data.data : r.data)
          } else {
            reject((r.data && r.data.header && r.data.header.msg) || 'Falha ao enviar captura.')
          }
        })
        .catch(err => {
          const msg =
            (err.response &&
              err.response.data &&
              err.response.data.header &&
              err.response.data.header.msg) ||
            (err.response && err.response.data && err.response.data.message) ||
            (err && err.message)

          reject(msg)
        })
    })
  }

  /**
   * Fortface capture de documento: mesmo payload do capture facial, POST para /api/fortface/capture/doc.
   * Fluxo: startDoc() -> handshake -> startSessionDoc() -> enviar dados aqui.
   */
  fortfaceCaptureDoc(
    externalUserId,
    data,
    sessionDetails,
    sessionKey,
    sessionToken,
    deviceRequestInfo,
    token,
  ) {
    return new Promise((resolve, reject) => {
      const url = `${fanPageUrl}/api/fortface/capture/doc`
      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }

      if (deviceRequestInfo != null && deviceRequestInfo !== '') {
        headers.devicerequestinfo = deviceRequestInfo
      }

      const enc = data.encryptData || {}
      const payload = {
        action: 'capture',
        externalUserId,
        encryptData: {
          data: enc.data,
          imgData: enc.imgData,
          key: enc.key != null && enc.key !== '' ? enc.key : sessionKey,
        },
        sessionToken: sessionToken != null ? sessionToken : undefined,
      }

      if (sessionDetails && sessionDetails.metrics) {
        payload.sessionDetails = { metrics: sessionDetails.metrics }
      }

      if (data.imgPreview != null && data.imgPreview !== '') {
        payload.imgPreview = data.imgPreview
      }

      if (deviceRequestInfo != null && deviceRequestInfo !== '') {
        payload.deviceRequestInfo = deviceRequestInfo
      }

      axios
        .post(url, payload, { headers })
        .then(r => {
          if (r.data && r.data.header && r.data.header.codigo === 1) {
            resolve(r.data.data != null ? r.data.data : r.data)
          } else {
            reject(
              (r.data && r.data.header && r.data.header.msg) ||
                'Falha ao enviar captura do documento.',
            )
          }
        })
        .catch(err => {
          const msg =
            (err.response &&
              err.response.data &&
              err.response.data.header &&
              err.response.data.header.msg) ||
            (err.response && err.response.data && err.response.data.message) ||
            (err && err.message)

          reject(msg)
        })
    })
  }
}
